export default {
    setConnectedAccounts(state, payload) {
        state.connectedInstagramAccounts = payload;
    },
    setKeywords(state, payload) {
        state.instagramKeywords = payload;
    },
    setInstagramAccounts(state,payload){
        state.instagramAccounts = payload;
    }
}